import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withTheme } from "styled-components";
import SurveyReader from "../../library/SurveyReader/SurveyReader";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import {
  mapDispatchToProps,
  mapStateToProps,
  eligibilitySurveyReducer,
} from "./EligibilitySurvey.store";
import { modalHeaders, modalType } from "../../../modules/constants";

export const EligibilitySurvey = ({
  fetchSurvey,
  surveyData,
  setOpenAuthModal,
  setSurveyTitle,
  resetState,
}) => {
  useEffect(() => {
    if (!surveyData)
      fetchSurvey().catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  }, [fetchSurvey, surveyData]);

  useEffect(() => {
    if (surveyData?.title) {
      setSurveyTitle(surveyData?.title);
    }
  }, [setSurveyTitle, surveyData]);

  const handleSurveyComplete = () => {
    setOpenAuthModal(modalType.register, modalHeaders.register);
  };

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  return (
    <SurveyReader
      surveyData={surveyData}
      onComplete={() => handleSurveyComplete()}
    />
  );
};

export default withTheme(
  dynamic(
    "eligibilitySurveyReducer",
    subspaced({
      mapExtraState: (state, rootState) => ({
        loginReducer: state.loginReducer,
      }),
    }),
    attachReducer(eligibilitySurveyReducer)
  )(connect(mapStateToProps, mapDispatchToProps)(EligibilitySurvey))
);
